export function initLanguage(lang, name, form, setForm) {
    let _form = { ...form };

    let translations = _form.translations[name] || {};

    if (!(lang in translations)) {
        translations[lang] = '';
    }

    _form.translations[name] = translations;

    setForm({ ..._form }, true);
}

export function handleTranslations(value, property, selectedLanguage, form, setForm, defaultLanguage, allowedLanguages) {
    let _form = { ...form };
    let trans = _form[`translations`];
    if (!(property in trans)) {
        trans[property] = {};
    }
    let translations = trans[property];

    translations[selectedLanguage] = value;

    if (selectedLanguage === defaultLanguage) {
        _form[property] = value;
    }

    setForm({ ..._form });
}
